// extracted by mini-css-extract-plugin
module.exports = {"container":"RoleSelect_container__RXkgY","title":"RoleSelect_title__3ZUJb"};